import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "lockCheck"
const LockCheckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 10c-1.106.003-2 .901-2 2.008v6.983C5 20.098 5.898 21 7.006 21h5.036l-1.556-1.556a2 2 0 0 1 0-2.829l1.323-1.323a2 2 0 0 1 2.829 0l1.233 1.232L19 13.396V12.01A2.009 2.009 0 0 0 17 10V7A5 5 0 0 0 7 7v3Zm4.9 8.03L14.87 21l1 1 1-1L19 18.87l3.047-3.047-1.323-1.323L19 16.224l-3.13 3.129-2.646-2.647-1.324 1.323ZM9 10V7a3 3 0 1 1 6 0v3H9Z"
          />
        </svg>
      }
    </span>
  )
}
export default LockCheckIcon
